<template>
  <div class="createSalesOrder">

    <div class="wrap">
      <div class="wrap__center">

        <h3>Create Sales Order</h3>

        <!-- select and btn -->
        <el-row>
          <el-col :span="12">

            <!-- select client -->
            <el-select v-if="!internalUse" v-model="companyClientId" placeholder="Selecte client" size="small" style="margin-right: 20px;">
              <el-option v-for="item in this.companyClientList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

            <!-- internal use -->
            <el-switch
              v-model="internalUse"
              active-text="Internal use">
            </el-switch>

          </el-col>
          <el-col :span="12" style="text-align: right;">

            <!-- btn -->
            <el-button @click="handleAddMaterial" v-if="companyClientId || internalUse" type="primary" plain size="mini" icon="el-icon-plus">Add Material</el-button>
            <!-- <el-button @click="handleAddTime" :disabled="!companyClientId" type="primary" plain size="mini" icon="el-icon-plus">Add Time</el-button> -->
            <!-- <el-button @click="handleAddExpense" :disabled="!companyClientId" type="primary" plain size="mini" icon="el-icon-plus">Add Expense</el-button> -->

          </el-col>
        </el-row>

        <!-- form -->
        <el-form v-if="companyClientId || internalUse" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="150px" label-position="left">

          <!-- header -->
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item label="Invoice number" prop="invoiceNumber" size="mini">
                <el-input v-model="ruleForm.invoiceNumber" placeholder="Invoice number" clearable></el-input>
              </el-form-item>

              <el-form-item label="Issue Date" prop="issueDate" size="mini">
                <el-date-picker type="date"
                  format="d MMM yy"
                  placeholder="Issue Date"
                  v-model="ruleForm.issueDate"
                  value-format="ddMMyyyy"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="Due Date" prop="dueDate" size="mini">
                <el-select v-model="ruleForm.dueDate" placeholder="Due Date" style="width: 100%;">
                  <el-option v-for="item in ruleForm.dueDateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-if="ruleForm.dueDate == 1" label="Custom Due Date" size="mini">
                <el-input type="number" v-model="ruleForm.customDueDate" placeholder="Custom Due Date"></el-input>
              </el-form-item>

              <el-form-item label="Currency" prop="currency" size="mini">
                <el-input v-model="ruleForm.currency" placeholder="Currency" disabled></el-input>
              </el-form-item>

              <el-form-item v-if="!internalUse" label="Customer Contact" size="mini">
                <el-input v-model="ruleForm.customerContact" disabled placeholder="Customer Contact"></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="12">

              <el-form-item label="Invoice Template" prop="invoiceTemplate" size="mini">
                <el-select v-model="ruleForm.invoiceTemplate" placeholder="Invoice Template" style="width: 100%;">
                  <el-option v-for="item in ruleForm.invoiceTemplateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Amounts Are" prop="amountsAre" size="mini">
                <el-select v-model="ruleForm.amountsAre" placeholder="Amounts Are" style="width: 100%;" clearable>
                  <el-option v-for="item in ruleForm.amountsAreList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Discount %" prop="discount" size="mini">
                <el-input type="number" min="0" max="100" v-model="ruleForm.discount" @change="changeTable()" placeholder="Discount" clearable onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>

              <el-form-item label="Subject" prop="subject">
                <el-input type="textarea" v-model="ruleForm.subject"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- title -->
          <el-row :gutter="10" class="selectRowTitle">
            <el-col :span="3">
              <div class="selectRowTitle__item">Item</div>
            </el-col>
            <el-col :span="8">
              <div class="selectRowTitle__item">Short note</div>
            </el-col>
            <el-col :span="2">
              <div class="selectRowTitle__item">Qty</div>
            </el-col>
            <el-col :span="2">
              <div class="selectRowTitle__item">Price per unit</div>
            </el-col>
            <el-col :span="2">
              <div class="selectRowTitle__item">Discount %</div>
            </el-col>
            <el-col :span="3">
              <div class="selectRowTitle__item">Taxes</div>
            </el-col>
            <el-col :span="2">
              <div class="selectRowTitle__item">Amount</div>
            </el-col>
            <el-col :span="2"></el-col>
          </el-row>

          <!-- add row for table -->
          <el-form :model="selectRow" :rules="rulesRow" ref="selectRow" label-width="0px" class="demo-ruleForm">

            <el-row :gutter="10">
              <el-col :span="3">
                <el-form-item prop="typeId" size="mini">
                  <el-select v-model="selectRow.typeId" placeholder="Select item" size="mini" style="width: 100%;">
                    <el-option v-for="item in itemList"
                      :key="item.serviceIndex"
                      :label="item.name"
                      :value="item.id"
                      @click.native="changeItem(item.name, item.projectTaxId)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="shortNote" size="mini">
                  <el-input v-model="selectRow.shortNote" placeholder="Short note" size="mini" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item prop="quantity" size="mini">
                  <el-input type="number" v-model="selectRow.quantity" @keyup.native="changeRow()" placeholder="Quantity" size="mini" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item prop="pricePerUnit" size="mini">
                  <el-input type="number" v-model="selectRow.pricePerUnit" @keyup.native="changeRow()" placeholder="Unit Price" size="mini" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item size="mini">
                  <el-input type="number" v-model="selectRow.discount" @keyup.native="changeRow()" placeholder="Discount" size="mini" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item prop="taxId" size="mini">
                  <el-select v-model="selectRow.taxId" placeholder="Taxes" size="mini" style="width: 100%;">
                    <el-option v-for="item in ruleForm.taxesList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @click.native="changeTaxes(item.id)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item size="mini">
                  <el-input disabled type="number" v-model="selectRow.amount" placeholder="Amount" size="mini"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button @click="createRow('selectRow')" type="primary" plain size="mini" style="width: 100%;">Add</el-button>
              </el-col>
            </el-row>

          </el-form>

          <!-- table -->
          <el-row>
            <el-col :span="24">
              <el-table
                :data="tableList.filter(data => !search || data.projectTaskName.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%">
                <el-table-column
                  label="Item"
                  prop="typeName"
                  sortable>
                </el-table-column>
                <el-table-column
                  label="Short note">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.shortNote" placeholder="Short note" size="mini"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Qty">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.quantity" @keyup.native="changeTable(scope.row)" placeholder="Quantity" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Price per unit">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.pricePerUnit" @keyup.native="changeTable(scope.row)" placeholder="Price per unit" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Discount %">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.discount" @keyup.native="changeTable(scope.row)" placeholder="Discount" size="mini" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Taxes">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.taxId" placeholder="Taxes" size="mini" style="width: 100%;">
                      <el-option v-for="item in ruleForm.taxesList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="changeTable()">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Amount"
                  prop="amount">
                </el-table-column>
                <el-table-column
                  align="right">
                  <template slot="header" slot-scope="{}">
                    <el-input
                      v-model="search"
                      size="mini"
                      placeholder="Type to search"/>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

          <!-- footer -->
          <el-row type="flex" justify="end">
            <el-col :span="10">
              <div class="price">
                <div v-if="ruleForm.amountsAre == 1" class="price__item">
                  <div>Includes Tax of</div>
                  <div>{{taxInclusive || '0.00'}}</div>
                </div>
                <div class="price__item price__item_border">
                  <div>Total Discount</div>
                  <div>{{totalDiscount || '0.00'}}</div>
                </div>
                <div class="price__item">
                  <div>Subtotal</div>
                  <div>{{ruleForm.subtotal || '0.00'}}</div>
                </div>
                <div v-if="ruleForm.amountsAre == 0" class="price__item">
                  <div>+ Tax of</div>
                  <div>{{taxExclusive || '0.00'}}</div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" style="background: #e3e4e6;">
              <el-row type="flex" justify="space-between" style="margin-bottom: 0px;">
                <el-col :span="4" class="createInvoice">
                  <el-button type="success" @click="submitForm('ruleForm')">Create Sales Order</el-button>
                </el-col>

                <el-col :span="10">
                  <div class="amount">
                    <div>Total Amount: </div>
                    <div>{{totalAmount}} {{ruleForm.currency}}</div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

        </el-form>

      </div>
    </div>

    <!-- Modal Add Material -->
    <sweet-modal blocking ref="addMaterial" class="modal">
      <h1 class="modal__title">Add Material</h1>

      <el-table
        ref="multipleTable"
        :data="tableDataMaterialList"
        style="width: 100%"
        @selection-change="handleSelectionChangeAddMaterial">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          property="projectTaskName"
          label="Task Name">
        </el-table-column>
        <el-table-column
          property="shortNote"
          label="Short note">
        </el-table-column>
        <el-table-column
          align="right"
          property="amount"
          label="Amount">
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="end" style="margin-top: 20px;">
        <el-col :span="4">
          <el-button @click="closeModalMaterial" type="primary" plain size="mini">Add</el-button>
        </el-col>
      </el-row>

    </sweet-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import _ from 'lodash';
import axios from 'axios'

export default {
  name: 'createSalesOrder',
  components: {
    SweetModal,

  },
  computed: {
    ...mapGetters(['getSalesOrderDirectories']),
    totalDiscount() {
      return this.ruleForm.totalDiscount
    },
    taxExclusive() {
      return this.ruleForm.taxesExc
    },
    taxInclusive() {
      return this.ruleForm.taxesInc
    },
    totalAmount() {
      return this.ruleForm.amountsAre == 0 ? (+this.ruleForm.subtotal + +this.taxExclusive).toFixed(2) : (+this.ruleForm.subtotal).toFixed(2)
    },
  },
  watch: {
    getSalesOrderDirectories(val) {
      this.companyClientList = val.companyClientList
      this.ruleForm.taxesList = val.projectTaxList
      this.itemList = val.companyInventoryItemList
      this.ruleForm.chartOfAccountList = val.companyChartOfAccountItemList
    },
    tableList(val) {
      this.changeTable()
    },
    internalUse(val) {
      if (val) {
        this.companyClientId = null
        this.ruleForm.customerContact = ''
      }
    }
  },
  created() {
    this.salesOrderDirectories()
  },
  data() {
    return {
      internalUse: false,
      companyClientId: null,
      companyClientList: [],

      ruleForm: {
        invoiceNumber: '',
        issueDate: '',
        dueDate: '',
        customDueDate: '',
        dueDateList: [{
            label: 'Custom',
            value: '1',
          },{
            label: 'Upon Receipt',
            value: '-1',
          },{
            label: '7 Days',
            value: '7',
          },{
            label: '15 Days',
            value: '15',
          },{
            label: '30 Days',
            value: '30',
          },{
            label: '60 Days',
            value: '60',
        }],
        currency: '',
        currencyId: '',
        customerContact: '',
        invoiceTemplate: 1,
        invoiceTemplateList: [{
          label: 'Default Template',
          value: 1,
        }],
        taxesList: [],
        chartOfAccountList: [],
        amountsAre: 0,
        amountsAreList: [{
            label: 'Tax Exclusive',
            value: 0,
          },{
            label: 'Tax Inclusive',
            value: 1,
        }],
        discount: null,
        subject: '',

        totalDiscount: null,
        subtotal: null,
        taxesExc: null,
        taxesInc: null,
      },

      rules: {
        invoiceNumber: [
          { required: true, message: 'Please input Invoice Number', trigger: 'blur' },
        ],
        issueDate: [
          { required: true, message: 'Please select Issue Date', trigger: 'change' }
        ],
        dueDate: [
          { required: true, message: 'Please select Due Date', trigger: 'change' }
        ],
        currency: [
          { required: true, message: 'Please select Currency', trigger: 'change' }
        ],
        // customerContact: [
        //   { required: true, message: 'Please select Customer Contact', trigger: 'change' }
        // ],
        invoiceTemplate: [
          { required: true, message: 'Please select Invoice Template', trigger: 'change' }
        ],
        amountsAre: [
          { required: true, message: 'Please select Invoice Template', trigger: 'change' }
        ],
        subject: [
          { required: true, message: 'Please select Subject', trigger: 'blur' }
        ],
      },
      rulesRow: {
        typeId: [
          { required: true, message: 'Please input Type', trigger: 'blur' },
        ],
        shortNote: [
          { required: true, message: 'Please select Short Note', trigger: 'change' }
        ],
        quantity: [
          { required: true, message: 'Please select Quantity', trigger: 'change' }
        ],
        taxId: [
          { required: true, message: 'Please select Taxes', trigger: 'change' }
        ],
        pricePerUnit: [
          { required: true, message: 'Please select Unit Price', trigger: 'change' }
        ],
        // chartOfAccountId: [
        //   { required: true, message: 'Please select Chart Of AccountId', trigger: 'change' }
        // ],
      },

      // Type
      itemList: [],

      // Select row
      selectRow: {
        itemId: null,
        shortNote: null,
        taxId: null,
        quantity: 1,
        pricePerUnit: null,
        // costPrice: null,
        // markUp: null,
        discount: null,
        discountSum: null,
        amount: null,
      },

      // Main table
      tableList: [],
      search: '',

      // Add Material
      tableDataMaterialList: [],
      multipleSelectionAddMaterial: [],
    }
  },
  methods: {
    ...mapActions(['salesOrderDirectories']),
    // change row
    changeRow() {
      this.selectRow.amount = this.selectRow.pricePerUnit
      this.selectRow.amount = (+this.selectRow.pricePerUnit - ((this.selectRow.pricePerUnit * this.selectRow.discount) / 100)).toFixed(2)
      this.selectRow.amount = (+this.selectRow.amount * +this.selectRow.quantity).toFixed(2)
      this.selectRow.discountSum = ((this.selectRow.pricePerUnit * this.selectRow.discount) / 100).toFixed(2)
    },
    // change table
    changeTable(row) {
      let amountAll = 0
      let discountAll = 0
      let taxesExcAll = 0
      let taxesIncAll = 0
      for (let i = 0; i < this.tableList.length; i++) {
        // quantity
        if (this.tableList[i].quantity === null) this.tableList[i].quantity = 1

        this.tableList[i].amount = (+this.tableList[i].pricePerUnit - ((this.tableList[i].pricePerUnit * this.tableList[i].discount) / 100)).toFixed(2)
        this.tableList[i].amount = (+this.tableList[i].amount * +this.tableList[i].quantity).toFixed(2)
        this.tableList[i].discountSum = ((this.tableList[i].pricePerUnit * this.tableList[i].discount) / 100).toFixed(2)
        this.tableList[i].taxesSumExc = 0
        this.tableList[i].taxesSumInc = 0

        let taxesValue = null
        for (let j = 0; j < this.ruleForm.taxesList.length; j++) {
          if (this.ruleForm.taxesList[j].id == this.tableList[i].taxes) {
            taxesValue = this.ruleForm.taxesList[j].value
          }
        }

        for (let k = 0; k < this.itemList.length; k++) {
          if (this.itemList[k].id == this.tableList[i].typeId) {
            this.tableList[i].typeName = this.itemList[k].name
          }
        }

        this.tableList[i].taxesSumExc = (+this.tableList[i].amount * taxesValue) / 100
        taxesExcAll += this.tableList[i].taxesSumExc

        this.tableList[i].taxesSumInc = +this.tableList[i].amount - ((+this.tableList[i].amount * 100) / (100 + taxesValue))
        taxesIncAll += this.tableList[i].taxesSumInc

        amountAll += +this.tableList[i].amount
        discountAll += +this.tableList[i].discountSum
      }

      this.ruleForm.subtotal = amountAll.toFixed(2)
      this.ruleForm.totalDiscount = discountAll.toFixed(2)
      this.ruleForm.taxesExc = taxesExcAll.toFixed(2)
      this.ruleForm.taxesInc = taxesIncAll.toFixed(2)

      if (!!this.ruleForm.discount && +this.ruleForm.subtotal > 0) {
        this.ruleForm.totalDiscount = (+this.ruleForm.totalDiscount + ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)

        this.ruleForm.subtotal = (+this.ruleForm.subtotal - ((+this.ruleForm.subtotal * +this.ruleForm.discount) / 100)).toFixed(2)
      }
    },

    changeTaxes(id) {
      this.ruleForm.taxesId = id
    },
    changeItem(value, taxId) {
      this.selectRow.taxId = taxId
    },

    // create row
    createRow(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let obj = {
            typeId: this.selectRow.typeId,
            typeName: this.selectRow.typeName,
            // type: null,
            shortNote: this.selectRow.shortNote,
            hoursSpent: this.selectRow.hoursSpent,
            minutesSpent: this.selectRow.minutesSpent,
            taxId: this.selectRow.taxId,
            quantity: this.selectRow.quantity,
            pricePerUnit: this.selectRow.pricePerUnit,
            discount: this.selectRow.discount,
            discountSum: this.selectRow.discountSum,
            amount: this.selectRow.amount,
            // chartOfAccountId: this.selectRow.chartOfAccountId
          }
          // if (this.selectRow.typeName == 'Time') {
          //   obj.type = 'Type Cast'
          // }
          this.tableList.push(obj)

          this.$refs['selectRow'].resetFields();
          this.selectRow.typeId = null
          this.selectRow.hoursSpent = null
          this.selectRow.minutesSpent = null
          this.selectRow.discount = null
          this.selectRow.discountSum = null
          this.selectRow.amount = null
          this.selectRow.quantity = 1
          // this.selectRow.chartOfAccountId = null
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // delete row
    handleDelete(index, row) {
      this.$confirm('This will permanently delete item? Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete'
        });

        this.tableList.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    // create invoice
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          // this.ruleForm.dueDate
          if (this.ruleForm.customDueDate) {
            this.ruleForm.dueDate = this.ruleForm.customDueDate
          }

          if (this.ruleForm.discount == '') this.ruleForm.discount == null


          let list = [];
          this.tableList
          for (let i = 0; i < this.tableList.length; i++) {
            let obj = {
              projectTaskId: null,
              // ! projectTaskProgressId -> projectProgressId
              projectTaskProgressId: null,
              // ! projectTaskExpenseId -> projectExpenseId
              projectTaskExpenseId: null,

              // ! companyInventoryItemId -> typeId
              companyInventoryItemId: null,
              // typeName: null,
              // type: null,
              projectTaskCostType: null,
              // projectTaskName: null,
              shortNote: null,
              discount: null,
              discountSum: null,
              hoursSpent: null,
              minutesSpent: null,
              // ! quantity -> quantity
              quantity: null,
              pricePerUnit: null,
              amount: null,
              // ! projectTaxId -> taxId
              projectTaxId: null,
              // ! taxSumInclude -> taxesSumInc
              taxSumInclude: null,
              // ! taxSumExclude -> taxesSumExc
              taxSumExclude: null,
              // ! taxSumExclude -> companyChartOfAccountItemId
              // companyChartOfAccountItemId: null,
            }

            // if (this.tableList[i].hoursSpent) {
            //   obj.hoursSpent = this.tableList[i].hoursSpent
            // }
            // if (this.tableList[i].minutesSpent) {
            //   obj.minutesSpent = this.tableList[i].minutesSpent
            // }

            // obj.companyChartOfAccountItemId = this.tableList[i].chartOfAccountId

            if (this.tableList[i].projectTaskCostType == 1) {
              obj.projectTaskId = this.tableList[i].projectTaskId
            } else if (this.tableList[i].projectTaskCostType == 2 || this.tableList[i].projectTaskCostType == 3) {
              obj.projectTaskProgressId = this.tableList[i].id
            } else if (this.tableList[i].typeName == 'Expense') {
              obj.projectTaskExpenseId = this.tableList[i].id || null
            }

            if (this.tableList[i].quantity === null) {
              obj.quantity = 1
            } else {
              obj.quantity = +this.tableList[i].quantity
            }

            // obj.type = this.tableList[i].type
            obj.companyInventoryItemId = this.tableList[i].typeId
            // obj.typeName = this.tableList[i].typeName
            // obj.projectTaskName = this.tableList[i].projectTaskName
            obj.projectTaskCostType = this.tableList[i].projectTaskCostType || null
            obj.shortNote = this.tableList[i].shortNote
            obj.discount = +this.tableList[i].discount
            obj.discountSum = +this.tableList[i].discountSum
            obj.pricePerUnit = this.tableList[i].pricePerUnit
            obj.amount = +this.tableList[i].amount
            obj.projectTaxId = this.tableList[i].taxId
            obj.taxSumInclude = +this.tableList[i].taxesSumInc
            obj.taxSumExclude = +this.tableList[i].taxesSumExc


            list.push(obj)
          }

          axios
          .post(`/api/v1/project-quotation/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`, {
            quotation: {
              customerCompanyClientId: this.companyClientId,
              no: this.ruleForm.invoiceNumber,
              issueDate: this.ruleForm.issueDate,
              dueDate: this.ruleForm.dueDate,
              currencyId: this.ruleForm.currencyId,
              customerEmail: this.ruleForm.customerContact,
              projectInvoiceTemplateId: this.ruleForm.invoiceTemplate,
              includeTax: this.ruleForm.amountsAre,
              // projectTaxId: this.ruleForm.taxesId,
              discount: +this.ruleForm.discount,
              subject: this.ruleForm.subject,
            },

            itemList: list,
          })
          .then(response => {
            this.notification("Success", "Add invoice", "success");
            this.$router.push(`/invoices?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            loader.hide()
          })
          .catch(error => {
            loader.hide()
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // open modal
    handleAddMaterial() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/project-quotation/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&clientId=${this.companyClientId}&operation=create`)
        .then(response => {
          this.$refs['addMaterial'].open()
          loader.hide()
          console.log('---/project-quotation/directories', response.data)

          // let taskList = response.data.projectTaskList
          // let expenseList = response.data.projectTaskExpenseList
          // let list = []

          let materialsList = response.data.materialsList
          let list = []

          for (let i = 0; i < materialsList.length; i++) {
            if (materialsList[i].projectTaskId) {
              // materialsList[i].projectTaskId = materialsList[i].projectTaskId
              materialsList[i].projectTaskName = materialsList[i].general.projectTask.name
            } else {
              materialsList[i].projectTaskId = null
              materialsList[i].projectTaskName = null
            }

            materialsList[i].projectTaskCostType = null
            // materialsList[i].taxId = materialsList[i].taxId
            // materialsList[i].shortNote = materialsList[i].shortNote
            materialsList[i].typeId = materialsList[i].itemId
            // materialsList[i].discount = materialsList[i].discount
            materialsList[i].discountSum = null
            // materialsList[i].amount = materialsList[i].amount
            materialsList[i].amount = (materialsList[i].unitPrice).toFixed(2)
            // materialsList[i].amount = materialsList[i].amount
            // materialsList[i].quantity = materialsList[i].quantity

            list.push(materialsList[i])
          }

          if (this.tableList.length > 0) {
            var tempArrId = this.tableList.map(item => item.id);
            let delList = _.remove(list, (n) => {
              return tempArrId.indexOf(n.id) != -1;
            });
          }

          this.tableDataMaterialList = list
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },

    // close modal
    closeModalMaterial() {
      for (let i = 0; i < this.multipleSelectionAddMaterial.length; i++) {
        this.tableList.push(this.multipleSelectionAddMaterial[i])
      }
      this.$refs['addMaterial'].close()
    },
    handleSelectionChangeAddMaterial(val) {
      this.multipleSelectionAddMaterial = val;
    },

    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
  .createSalesOrder {
    background: #f2f4f7;
    height: 100vh;
  }

  .wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 70px 10px 10px 10px;
    height: 100%;
    overflow-y: auto;

    &__center {
      min-width: 1300px;
      // padding-bottom: 20px;
      h3 {
        margin: 0;
        font-size: 14px;
        color: #909399;
        margin-bottom: 10px;
      }
    }
  }

  .modal {
    &__title {
      text-align: center;
    }
    &__btn {
      text-align: right;
    }
  }

  .price {
    padding: 20px;
    font-weight: bold;
    &__item{
      display: flex;
      justify-content: space-between;
      padding: 4px;
      &_border{
        border-bottom: 1px solid #000;
      }
    }
  }

  .createInvoice {
    padding: 20px;
    font-size: 30px;
  }

  .amount {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    font-size: 30px;
    font-weight: bold;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .selectRowTitle {
    font-size: 14px;
    font-weight: bold;
    color: #909399;
    &__item {
      padding-left: 10px;
    }
  }
</style>

